const CalculatorLabelsObject = class CalculatorLabels {

  constructor(calculationsStyle = null) {
    this._calculationsStyle = calculationsStyle;
  }

  common = {
    coolingPower: ['kW', 'BTU/min'],
    power: ['kW', 'HP'],
    temperature: ['°C', '°F'],
    oilPressure: ['bar', 'psi']
  }

  labels = {
    oilFlowRate: ['l/min', 'GPM'],
    oilPressure: this.common.oilPressure,
    oilPressureDrop: this.common.oilPressure,
    efficiency: ['-', '-'],
    motorPower: this.common.power,
    coolingPower: this.common.coolingPower,
    aboveSeaLevel: ['m', 'feet'],
    airInletTemperature: this.common.temperature,
    oilInletTemperature: this.common.temperature,
    airOutletTemperature: this.common.temperature,
    oilOutletTemperature: this.common.temperature,
    specificCoolingCapacity: ['kW/°C', 'BTU/min°F'],
    noise_level: ['dB(A)', 'dB(A)'],
    current: ['A', 'A'],
    frequency: ['Hz', 'Hz'],
    rotationSpeed: ['1/min', '1/min'],
    airFlowRate: ['kg/s', 'CFM'],
    weight: ['kg', 'lb'],
    tankCapacity: ['Liter', 'gallons'],
    startingTemperature: this.common.temperature,
    endTemperature: this.common.temperature,
    heatingTime: ['h', 'h'],
    fulfillment: ['%', '%']
  }

  get(name, strict = true) {

    if (strict) {
      return this.labels[name]
        ? this.labels[name][this.getArrayKey(this._calculationsStyle ?? Spruce.store('configurator').calculationStyle)]
        : null
    }
    return this.labels[name]
      ? this.labels[name][this.getArrayKey(
        this._calculationsStyle ?? Spruce.store('configurator').getDisplayStyle()
      )]
      : null
  }

  getByNameAndCalcMethod(name, calcMethod) {
    return this.labels[name] ? this.labels[name][this.getArrayKey(calcMethod)] : null
  }

  getArrayKey(calculationStyle) {

    if (calculationStyle === 'metric')
      return 0

    if (calculationStyle === 'imperial')
      return 1

  }

}

const CalculatorLabels = (calculationsStyle = null) => {
  return new CalculatorLabelsObject(calculationsStyle)
}

export default CalculatorLabels
